import { AiShoppableImageError } from "./AiShoppableImageError";

export class FailedToDetectPois extends AiShoppableImageError {}